import React, { useRef } from "react";
import "./contact.css";
import { MdOutlineEmail } from "react-icons/md";
import { RiMessengerLine } from "react-icons/ri";
import { BsWhatsapp } from "react-icons/bs";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_jztc0b1",
        "template_iuppny7",
        form.current,
        "gkCJJMuUk_T3ilq_3"
      )

          e.target.reset()

      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <section id="contact">
      <h5>צור קשר</h5>
      <h2>דבר אלי</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineEmail className="contact__option-icon" />
            <h4> Email </h4>
            <h5>mtyg7702@gmail.com</h5>
            <a href="mailto:mtyg7702@gmail.com" target="_blank">
              שלח הודעה
            </a>
          </article>
          <article className="contact__option">
            <RiMessengerLine className="contact__option-icon" />
            <h4> Messenger </h4>
            <h5>facebook.com/maty770 </h5>
            <a
              href="https://www.facebook.com/messages/t/102367485923949"
              target="_blank"
            >
              שלח הודעה
            </a>
          </article>
          <article className="contact__option">
            <BsWhatsapp className="contact__option-icon" />
            <h4> Whatsapp </h4>
            <h5>0547700019</h5>
            <a href="http://wa.me/+972547700019" target="_blank">
              שלח הודעה
            </a>
          </article>
        </div>
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name="name" placeholder="שם מלא" required />
          <input
            type="email"
            name="email"
            placeholder=" הקלד אימייל"
            required
          />
          <textarea
            name="message"
            rows="7"
            placeholder="הקלד הודעה"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary">
            {" "}
            שלח
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
